import {
  Grid2,
  Radio,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import React, { useEffect } from "react";
import styles from "./CreateOrgSignupStyle.module.scss";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import Dropdown from "../../../../GlobalComponents/Dropdown/Dropdown";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { ReactComponent as DeleteIcon } from "../../../../GlobalAssets/svg/Delete.svg";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";

function CreateOrgSignup({
  orgName,
  setOrgForm,
  formFieldUpdate,
  suffix,
  nameLoading,
  isCreateOrg,
  orgForm,
  handleMemberEmailChange,
  roleOptions,
  handleRoleChange,
  addInviteInput,
  removeInviteInput,
  isBilling,
  isCreatedisabled,
  handleContinue,
  handleOpenCreate,
  limitError,
  orgData,
  verifying,
  selectOrg,
  setSelectOrg,
  userDetails,
  updated,
  showMembers,
  handleToggleMembers,
}) {
  useEffect(() => {
    if (userDetails && orgData?.length > 0) {
      setSelectOrg(true);
    }
  }, [userDetails]);

  const organizationName = orgName ? orgName : orgForm.selectOrganization.label;

  const shouldShowSelectText =
    (!selectOrg && !isBilling) ||
    (isBilling && orgForm.selectOrganization.label !== undefined) ||
    orgName;

  const renderDeleteIcon = (index) => (
    <Grid2
      className={`${styles.deleteIconContainer} ${
        index !== 0 ? styles.deleteIconContainerAdjusted : ""
      }`}
    >
      <DeleteIcon
        className={styles.deleteIcon}
        onClick={() => removeInviteInput(index)}
      />
    </Grid2>
  );

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.createContainer}>
        <Grid2 className={styles.label20}>Manage Sites with Your Team</Grid2>
        {!updated ? (
          isBilling && organizationName === undefined ? (
            <Grid2 onClick={handleOpenCreate} className={styles.createLabel}>
              {(isBilling && orgData?.length > 0) || organizationName
                ? "Select existing organizations"
                : "Create"}
            </Grid2>
          ) : orgData?.length > 0 ? (
            <Grid2 onClick={handleOpenCreate} className={styles.createLabel}>
              {shouldShowSelectText
                ? "Select existing organizations"
                : "Create"}
            </Grid2>
          ) : null
        ) : null}
      </Grid2>

      {isBilling && organizationName === undefined && (
        <Grid2 className={styles.indvNote}>
          <strong>Note:</strong>{" "}
          <span>
            You've selected an individual plan. If you'd like to collaborate
            with your team, you can add your organization's name here and invite
            members to manage your sites together. Skip this step if you're
            managing the sites solo.
          </span>
        </Grid2>
      )}

      {!isBilling
        ? isCreateOrg && (
            <>
              <hr className={styles.line} />
              <Grid2>
                {((userDetails && selectOrg && orgData?.length > 0) ||
                  orgForm.selectOrganization.label) && (
                  <Dropdown
                    title="Select organization"
                    options={orgData.map((org) => ({
                      label: org.name,
                      value: org.orgId,
                    }))}
                    placeholder="Select an option"
                    value={orgForm.selectOrganization.value}
                    onSelect={(option) => {
                      setOrgForm((prevState) => ({
                        ...prevState,
                        selectOrganization: {
                          value: option,
                          label: orgData.find((org) => org.orgId === option)
                            ?.name,
                        },
                      }));
                    }}
                  />
                )}
                {((!selectOrg &&
                  userDetails &&
                  (orgData === undefined ||
                    orgForm.selectOrganization.label === undefined)) ||
                  userDetails?.emailId === undefined) && (
                  <CustomInput
                    title="Organization Name"
                    SubTitle="Legal name of your organization"
                    placeholder="Enter Organization Name"
                    value={orgName?.toLowerCase()}
                    setValue={(e) => {
                      if (e.length <= 24) {
                        formFieldUpdate("orgName", e);
                      }
                    }}
                    nameLoading={nameLoading}
                    suffix={suffix}
                    error={orgForm.orgNameError}
                    errorMessage={orgForm.orgNameErrorMessage}
                    fontSize={true}
                  />
                )}
              </Grid2>
              {!selectOrg && isCreateOrg && (
                <Grid2 className={styles.label14}>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={showMembers}
                        onClick={handleToggleMembers}
                      />
                    }
                    label={
                      <div className={styles.addMembersLabel}>Add Members</div>
                    }
                    sx={{
                      "& .MuiRadio-root": {
                        color:
                          userDetails?.theme === "dark" ? "#ffffff" : "#000000",
                      },
                    }}
                  />
                </Grid2>
              )}
              {showMembers &&
                orgForm.members.map((invite, index) => {
                  const memberValue = invite.memberEmailId?.toLowerCase() || "";
                  const roleValue = invite.roleId || "";

                  return (
                    <Grid2 className={styles.inviteContainer} key={index}>
                      <CustomInput
                        placeholder={"example@example.com"}
                        value={memberValue}
                        setValue={(option) =>
                          handleMemberEmailChange(option, index)
                        }
                        error={orgForm.memberError[index]?.memberEmailIdError}
                        className={styles.inputWidth}
                        fontSize={true}
                      />

                      <Grid2 className={styles.dropdown}>
                        <Dropdown
                          options={roleOptions}
                          placeholder="Select an option"
                          value={roleValue}
                          onSelect={(option) => handleRoleChange(option, index)}
                          dropdownHeader={styles.dropdownList}
                          disabled={memberValue === ""}
                          fontSize={true}
                        />

                        {index === orgForm.members.length - 1 ? (
                          <>
                            <Grid2
                              className={`${styles.deleteIconContainer} ${
                                index !== 0
                                  ? styles.deleteIconContainerAdjusted
                                  : ""
                              }`}
                            >
                              <PersonAddAlt1Icon
                                onClick={
                                  memberValue && roleValue
                                    ? addInviteInput
                                    : undefined
                                }
                                className={
                                  memberValue && roleValue
                                    ? styles.addIconEnabled
                                    : styles.addIconDisabled
                                }
                              />
                            </Grid2>
                            {orgForm.members.length > 1 && (
                              <>{renderDeleteIcon(index)}</>
                            )}
                          </>
                        ) : (
                          <>{renderDeleteIcon(index)}</>
                        )}
                      </Grid2>
                    </Grid2>
                  );
                })}
              {limitError}
              <CustomButton
                onClick={handleContinue}
                disabled={!orgForm.selectOrganization || isCreatedisabled}
                className={styles.button}
              >
                {verifying ? (
                  <CircularProgress color="inherit" size={20} />
                ) : organizationName !== undefined ? (
                  orgForm.orgName !== "" ? (
                    "Create"
                  ) : (
                    orgForm.selectOrganization !== null && "Next"
                  )
                ) : (
                  "Skip"
                )}
              </CustomButton>
            </>
          )
        : isBilling &&
          organizationName !== undefined && (
            <Grid2 className={styles.billingContainer}>
              <Grid2 className={styles.label14}>Organization Name</Grid2>
              <Grid2 className={styles.orgNameLabel}>{organizationName}</Grid2>
            </Grid2>
          )}
    </Grid2>
  );
}

export default CreateOrgSignup;
